import { AllowedDeliveryChannel } from "../widget";
import { Campaign } from "./campaign";

export class LocationWidgetSettings {
  public locationId: number;
  public defaultWidgetSettingsId: number;
  public disabled: boolean;
  public deliveryMethod: AllowedDeliveryChannel;
  public location: Location;
  public defaultWidgetSettings: Campaign;
  public isEditing: boolean;
  public configured: boolean;
  public widgetSettingsJson: string;
  public landingUrl: string;
}
